import { EventType } from "@omni/types/components/tracking/eventType.enum";
import { ReviewImpressionTrackingInfo } from "@omni/types/components/tracking/tracking-info/impression/reviewImpression.trackingInfo";

import { getPageInfo, getUserInfo } from "@/services/tracking/trackers/utils";
import * as TrackingService from "@/services/tracking/tracking.service";
import { TypedAnalyticsEvent } from "@/services/tracking/types/analyticsEvent";

export const track = (trackingInfo: ReviewImpressionTrackingInfo) => {
    const event: TypedAnalyticsEvent<ReviewImpressionTrackingInfo> = {
        event: EventType.ReviewImpression,
        payload: {
            eventData: trackingInfo,
            pageInfo: getPageInfo(),
            userInfo: getUserInfo()
        }
    };

    TrackingService.track(event);
};
